export enum StatusColaborador {
    Inativo = 0,
    Ativo = 1,
    Removido = 2
}
